export const colors = {
	action: '#EA1C2E',  // red
	reverse: '#FFD520', // yellow
	active: '#0060A9',  // blue
	success: '#32863B', // green
	background: '#999', // gray
};
